import { render, staticRenderFns } from "./PortfolioPlanningEntrancePage.vue?vue&type=template&id=99ae7ba2"
import script from "./PortfolioPlanningEntrancePage.vue?vue&type=script&lang=ts"
export * from "./PortfolioPlanningEntrancePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports